import assign from 'lodash/assign'

import Dashboard from 'components/home/Dashboard.vue'

import FileCenter from 'components/file/FileCenter.vue'

import NoticeList from 'components/home/NoticeList.vue'
import NoticeDetail from 'components/home/NoticeDetail.vue'

import PlanList from 'components/plan/PlanList.vue'
import PlanEdit from 'components/plan/PlanEdit.vue'

import CollectionList from 'components/collection/CollectionList.vue'
import CollectionEdit from 'components/collection/CollectionEdit.vue'

import { achievement_map, achievement_routes } from './achievement'

export * from './achievement'

// 首页
export let dashboard = {
  path: 'dashboard',
  component: Dashboard,
}
// 文件共享
export let file_center = {
  path: 'file/center',
  component: FileCenter,
}
// 通知中心
export let notice_list = {
  path: 'notice/list',
  component: NoticeList,
}
export let notice_detail = {
  path: 'notice/detail',
  component: NoticeDetail,
}
// 教学计划
export let plan_list = {
  path: 'plan/list',
  component: PlanList,
}
export let plan_edit = {
  path: 'plan/edit',
  component: PlanEdit,
}
// 文件上传任务
export let collection_list = {
  path: 'collection/list',
  component: CollectionList,
}
export let collection_edit = {
  path: 'collection/edit',
  component: CollectionEdit,
}

export let home_routes = [
  dashboard,
  file_center,
  notice_list,
  notice_detail,
  plan_list,
  plan_edit,
  collection_list,
  collection_edit,
  ...achievement_routes,
]

export let home_map = assign({
  dashboard,
  file_center,
  notice_list,
  notice_detail,
  plan_list,
  plan_edit,
  collection_list,
  collection_edit,
}, achievement_map)



// WEBPACK FOOTER //
// ./src/router/routes/home/index.js